module.exports = __webpack_public_path__ + "static/media/rec.c09e7503.jpg";